import { render, staticRenderFns } from "./ConfigSmsTextInputPopup.vue?vue&type=template&id=16ef9387&scoped=true&"
import script from "./ConfigSmsTextInputPopup.vue?vue&type=script&lang=js&"
export * from "./ConfigSmsTextInputPopup.vue?vue&type=script&lang=js&"
import style0 from "./ConfigSmsTextInputPopup.vue?vue&type=style&index=0&id=16ef9387&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ef9387",
  null
  
)

export default component.exports